import { CollapseCurve } from '@/@types/global';
import { useGenerateReport } from '@/stores/GenerateReportStore';
import { setDate } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import Plot, { PlotParams } from 'react-plotly.js';

interface OverallReportChartProps {
  data: CollapseCurve[];
  width?: number;
  height?: number;
  onImageReady?: (base64: string) => void;
}

const OverallReportChart: React.FC<OverallReportChartProps> = ({
  data,
  width = 750,
  height = 600,
  onImageReady,
}) => {
  const plotRef = useRef<any>(null);
  const { testSelected, currentItem, setBase64Graphics } = useGenerateReport()  

  // Extrair dados para o gráfico
  const x = data.map((item) => Number(item.tempo));
  const y = data.map((item) => Number(item.pressao));
  const teste_colapso = currentItem && currentItem.teste_colapso ? Math.round(currentItem.teste_colapso) : '';

  const maxX = x.length > 0 ? Math.max(...x) : 0
  const maxY = y.length > 0 ? Math.max(...y) : 0;

  const gerarImagem = async () => {
    if (plotRef.current?.el && testSelected?.typeCode === 'collapse' && currentItem && data.length > 0) {
      try {
        const imgData = await Plotly.toImage(plotRef.current.el, {
          format: 'png',
          width,
          height,
        });
        setBase64Graphics(imgData);
      } catch (error) {
        console.error('Erro ao gerar imagem base64:', error);
        setBase64Graphics(undefined);
      }
    }else {
      setBase64Graphics(undefined);
    }
  };

  

  const getValueShapes = (text: string) => {
    try {
      const req_min_psi = text?.match(/\d+/g);
      if (req_min_psi && req_min_psi.length > 0) {
        const value = Number(req_min_psi[0]);
        if (!isNaN(value)) {
          return Math.round((value * 0.0689476));
        }
      }
    } catch (error) {
      console.error('Erro ao converter req_min_psi para número:', error);
    }
    return 0;
  }

  return (
    <div style={{ display: 'none' }}>
      <Plot
        ref={plotRef}
        data={[
          {
            x,
            y,
            type: 'scatter',
            mode: 'lines+markers',
            marker: { color: 'red', size: 1 },            
            name: 'Pressão vs Tempo',
          },
        ]}
        layout={{
          margin: { t: 10, b: 150 },
          annotations: [
            {
              xref: 'paper',
              yref: 'paper',
              x: 0.11,
              y: -0.22,
              text: `<span style="font-weight:bold;">Pressão mínima de colapso (minimum collapse pressure)(bar)</span>: ${getValueShapes(currentItem?.req_min_psi)}`,
              showarrow: false,
            },
            {
              xref: 'paper',
              yref: 'paper',
              x: 0.11,
              y: -0.26,
              text: `<span style="font-weight:bold;">Pressão de colapso (collapse pressure)(bar)</span>: ${teste_colapso}`,
              showarrow: false,
            },
            {
              xref: 'paper',
              yref: 'paper',
              x: 0.0,
              y: -0.18,
              text: '<span style="color:gold;">━━━━━</span> Pressão mínima (minimum pressure required)',
              showarrow: false,
            },
          ],
          xaxis: { title: { text: 'segundos (seconds)' }, tickmode: 'linear',
          tick0: 0,
          dtick: 30, // espaçamento entre os ticks
          range: [0, maxX] },
          yaxis: { title: { text: 'bar' }, tickmode: 'linear',
          tick0: 0,
          dtick: 50, // espaçamento entre os ticks
          range: [0, maxY] },
          shapes: [
              {
              type: 'line',
              xref: 'paper',
              x0: 0,
              x1: 1,
              yref: 'y',
              y0: getValueShapes(currentItem?.req_min_psi),
              y1: getValueShapes(currentItem?.req_min_psi),
              line: {
                  color: 'gold',
                  width: 3,
                  dash: 'solid',
              },
          }],
          width,
          height,
        }}
        onUpdate={() => gerarImagem() }
      />
    </div>
  );
};

export default OverallReportChart;